import * as ArrayUtils from '../../common/util/array';
import createReducer from '../../common/util/createReducer';
import {ActionTypes} from '../actions';
import {downloadFile} from '../../common/util/file';

const INITIAL_STATE = {
  'loading': false,
  'rejecting': false,
  'checkedAll': false,
  'list': [],
  'generatingTxt': false,
};

const updateTransport = (list, payload) => {
  const newList = [...list];
  const object = {...newList[payload.index]};
  object.transport = payload.value;

  return ArrayUtils.replaceItem(list, payload.index, object);
};

const removeItemFromSpecialsOrders = (list, index) => {
  const ordersList = [...list];
  ordersList.splice(index, 1);
  
  return ordersList;
};

const markItemInSpecialOrder = (list, index) => {
  const element = {...list[index]};
  element.checked = !element.checked;
  return ArrayUtils.replaceItem(list, index, element);
};

const updateAllElementsMark = (list, value) => {
  return list.map((element) => ({...element, 'checked': value}));
};

export const providerOrdersList = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.FETCHING_PROVIDER_SPECIAL_ORDERS]: (state, action) => ({
      ...state,
      'loading': true,
      'checkedAll': false,
    }),
    [ActionTypes.FETCHED_PROVIDER_SPECIAL_ORDERS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_PROVIDER_SPECIAL_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CHANGE_TRANSPORT_OPTIONS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': updateTransport(state.list, action.payload),
    }),
    [ActionTypes.REJECTING_PROVIDER_SPECIAL_ORDERS]: (state, action) => ({
      ...state,
      'rejecting': true,
    }),
    [ActionTypes.REJECTED_PROVIDER_SPECIAL_ORDERS]: (state, action) => ({
      ...state,
      'rejecting': false,
      'list': removeItemFromSpecialsOrders(state.list, action.payload),
    }),
    [ActionTypes.REJECTED_PROVIDER_SPECIAL_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'rejecting': false,
    }),
    [ActionTypes.GENERATING_TXT_FOR_PROVIDER_SPECIAL_ORDERS]: (state, action) => ({
      ...state,
      'generatingTxt': true,
    }),
    [ActionTypes.GENERATED_TXT_FOR_PROVIDER_SPECIAL_ORDERS]: (state, action) => {
      downloadFile(action.response.data);

      return ({
        ...state,
        'generatingTxt': false,
      });
    },
    [ActionTypes.GENERATED_TXT_FOR_PROVIDER_SPECIAL_ORDERS_FAILED]: (state, action) => ({
      ...state,
      'generatingTxt': false,
    }),
    [ActionTypes.ASK_FOR_PROVIDER_SPECIAL_AUTHORIZATION_REQUEST]: (state, action) => ({
      ...state,
      'generatingTxt': true,
    }),
    [ActionTypes.ASK_FOR_PROVIDER_SPECIAL_AUTHORIZATION_SUCCESS]: (state, action) => ({
      ...state,
      'generatingTxt': false,
    }),
    [ActionTypes.ASK_FOR_PROVIDER_SPECIAL_AUTHORIZATION_FAILED]: (state, action) => ({
      ...state,
      'generatingTxt': false,
    }),
    [ActionTypes.TOGGLE_MARK_IN_PROVIDER_SPECIAL_ORDER]: (state, action) => ({
      ...state,
      'list': markItemInSpecialOrder(state.list, action.payload),
    }),
    [ActionTypes.TOGGLE_ALL_PROVIDER_SPECIAL_ORDERS]: (state, action) => ({
      ...state,
      'checkedAll': !state.checkedAll,
      'list': updateAllElementsMark(state.list, !state.checkedAll),
    }),
  })(state, action);
};
